"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ListingImageV = _interopRequireDefault(require("../elements-image/ListingImageV2"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _placeholderImg = _interopRequireDefault(require("../elements-image/placeholderImg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var WhyPeerspace = function WhyPeerspace(_ref) {
  var _ref$sectionTitle = _ref.sectionTitle,
    sectionTitle = _ref$sectionTitle === void 0 ? '' : _ref$sectionTitle,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  var _items = _toArray(items),
    _items$ = _items[0],
    image = _items$ === void 0 ? {} : _items$,
    restOfItmes = _items.slice(1);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "WhyPeerspace"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid no-gutter"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "column-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-basis-50 img-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-small hidden-xs text-white imageDetailsContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "imageDetails column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "heavy"
  }, image.contentSubtitle1))), /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
    offset: 100,
    placeholder: _placeholderImg.default,
    once: true
  }, /*#__PURE__*/_react.default.createElement(_ListingImageV.default, {
    sizes: '(min-width: 769px) 50vw, 100vw',
    imgId: image.contentCloudinaryId,
    alt: image.imageAltText,
    ratio: 1440 / 1104,
    widths: ['600', '1600'],
    className: ""
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-basis-50 container-fluid content-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-9 col-lg-7"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "section-spacing"
  }, sectionTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "section-container"
  }, (restOfItmes || []).map(function () {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var i = arguments.length > 1 ? arguments[1] : undefined;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "section-spacing"
    }, /*#__PURE__*/_react.default.createElement("h6", null, item.contentTitle), /*#__PURE__*/_react.default.createElement("p", null, item.contentDescription));
  }))))))));
};
WhyPeerspace.propTypes = {
  items: _propTypes.default.array,
  sectionTitle: _propTypes.default.string
};
var _default = exports.default = WhyPeerspace;